function initKlaviyo() {
  var s = document.createElement('script');
  s.type = "text/javascript";
  s.async = true;
  s.src = "//static.klaviyo.com/onsite/js/klaviyo.js?company_id=QkCWPk&shop=kirrin-finch.myshopify.com";
  s.onload = function() {
    var _learnq = _learnq || [];

    document.querySelectorAll("[data-add-to-cart]").forEach(item => {
      item.addEventListener('click', event => {
        _learnq.push(['track', 'Added to Cart', item]);
      });
    });

    document.querySelectorAll("[data-quick-add]").forEach(item => {
      item.addEventListener('click', event => {
        window.setTimeout(function() {
          document.querySelectorAll("[data-add-to-cart]").forEach(item => {
            item.addEventListener('click', event => {
              _learnq.push(['track', 'Added to Cart', item]);
            })
          });
        }, 500);
      });
    });
  };

  document.body.appendChild(s);
  document.removeEventListener('scroll', initKlaviyo);
  document.removeEventListener('mousemove', initKlaviyo);
  document.removeEventListener('touchstart', initKlaviyo);
}

document.addEventListener('scroll', initKlaviyo, { once: true });
document.addEventListener('mousemove', initKlaviyo, { once: true });
document.addEventListener('touchstart', initKlaviyo, { once: true });
